"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.23,18.13H2.13A2.12,2.12,0,0,1,0,16V2.9A2.12,2.12,0,0,1,2.13.78h13.1A2.13,2.13,0,0,1,17.36,2.9V16A2.13,2.13,0,0,1,15.23,18.13ZM2.42,15.71H14.94V3.2H2.42Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.85,13.37a1.21,1.21,0,0,1-1.21-1.21V8A2.13,2.13,0,0,1,8.77,5.87h4.16a1.21,1.21,0,1,1,0,2.42H9.06v3.87A1.21,1.21,0,0,1,7.85,13.37Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.87,23.22H8.77A2.13,2.13,0,0,1,6.64,21.1v-.74a1.21,1.21,0,0,1,2.42,0v.44H21.58V8.29H20a1.21,1.21,0,1,1,0-2.42h1.9A2.12,2.12,0,0,1,24,8V21.1A2.12,2.12,0,0,1,21.87,23.22Zm0-14.93h0Z"
  }));
};

exports["default"] = _default;